import { ApiProperty } from "@nestjs/swagger";

export class ZipperBDto {
   @ApiProperty()
    id:number

    @ApiProperty()
    style:string

    @ApiProperty()
    size:string

    @ApiProperty()
    consumption:string

    @ApiProperty()
    createdUser?: string;

    @ApiProperty()
    isActive?: boolean;

    @ApiProperty()
    versionFlag?: number;

    @ApiProperty()
    createdAt?:string;
    
    @ApiProperty()
    updatedAt?:string;

    @ApiProperty()
    updatedUser?:string;

}